export default "__VITE_ASSET__VDVgJwQP__"